import React, {useCallback, useContext, useEffect, useState} from 'react';
import {ServiceContext} from '../Services';
import {Badge, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, styled} from '@mui/material';
import {Assignment} from '@mui/icons-material';
import {taskStatus} from '../../utilities';
import Detail from './Detail';
import List from './List';
import {useHistory} from 'react-router-dom';
import {reverse} from 'named-urls';
import routes from '../../routes';

const HeaderButton = styled(IconButton)(({theme}) => ({
  '&.MuiButtonBase-root': {
    margin: theme.spacing(0, 2, 0, 0),
  },
}));

const Title = styled(DialogTitle)(({theme}) => ({
  '&.MuiDialogTitle-root': {
    borderBottom: `2px solid ${theme.palette.background.default}`,
  },
}));

const Content = styled(DialogContent)(({theme}) => ({
  '&.MuiDialogContent-root': {
    background: theme.palette.background.default,
  },
}));

const Actions = styled(DialogActions)(({theme}) => ({
  '&.MuiDialogActions-root': {
    borderTop: `2px solid ${theme.palette.background.default}`,
  },
}));

const TaskManager = () => {
  const services = useContext(ServiceContext);
  const history = useHistory();
  const [tasks, setTasks] = useState([]);
  const [count, setCount] = useState(0);
  const [showList, setShowList] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    services.firebase.subscribeToMyTasks((tasks) => {
      setTasks(tasks);
      setCount(tasks.filter((task) => (['pending', 'overdue'].indexOf(taskStatus(task)) >= 0)).length);
    });
  }, [services]);

  const handleSelect = useCallback((task) => {
    setSelected(task);
    setShowDetail(true);
  }, []);

  return (
    <>
      <HeaderButton variant="contained" color="secondary" onClick={() => setShowList(true)}>
        <Badge badgeContent={count} color={count === 0 ? 'success' : 'error'}>
          <Assignment/>
        </Badge>
      </HeaderButton>
      <List
        open={showList}
        onClose={() => setShowList(false)}
        tasks={tasks}
        onTaskSelected={handleSelect}
      />
      <Dialog
        open={showDetail}
        onClose={() => setShowDetail(false)}
        maxWidth="xl"
        fullWidth={true}
      >
        <Title id="alert-dialog-title">{selected?.title}</Title>
        <Content>
          {selected ? (
            <Detail
              task={selected}
              onTaskUpdated={setSelected}
              onLoading={setLoading}
              onDeleted={() => setShowDetail(false)}
              onRestored={() => setShowDetail(false)}
              onChangeTask={(task) => {
                setShowDetail(false);
                setShowList(false);
                history.push(reverse(routes.tasks.detail, {id: task.id}));
              }}
            />
          ) : null}
        </Content>
        <Actions>
          <Button disabled={loading} onClick={() => setShowDetail(false)} variant="contained" color="primary">
            Close
          </Button>
        </Actions>
      </Dialog>
    </>
  );
}

export default TaskManager;